<template>
	<v-container fluid class="blue-grey lighten-5">
		<v-container grid-list-lg>
			<v-layout row wrap>
				<v-flex xs12 sm6 md4 xl4>
					<v-hover>
						<v-card height="100%" slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 2}`" shaped>
							<v-responsive>
								<v-flex xs6 align-center flexbox>
									<v-icon size="200">
										mdi-phone
										<br />
									</v-icon>
								</v-flex>
								<v-container fill-height fluid>
									<v-layout fill-height>
										<v-flex xs12 align-end flexbox></v-flex>
									</v-layout>
								</v-container>
							</v-responsive>
							<v-card-text>
								<div>
									<h2 class="font-weight-black black--text text-xs-right mb-1">شماره تماس</h2>
								</div>
								<v-divider></v-divider>
								<br />
								<h1 class="display-1 font-weight-light grey--text text-xs-center mb-2">041-7108</h1>
							</v-card-text>

							<v-card-actions>
								<v-spacer></v-spacer>
							</v-card-actions>
						</v-card>
					</v-hover>
				</v-flex>
				<v-flex xs12 sm6 md4 xl4>
					<v-hover>
						<v-card height="100%" slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 2}`" shaped>
							<v-responsive>
								<!-- <v-img :src="item.src" height="500px"> -->
								<v-flex xs6 align-center flexbox>
									<v-icon size="200">
										mdi-map-marker
										<br />
										<!-- <div class="text-block">
                                        </div>-->
									</v-icon>
								</v-flex>
								<v-container fill-height fluid>
									<v-layout fill-height>
										<v-flex xs12 align-end flexbox></v-flex>
									</v-layout>
								</v-container>
							</v-responsive>
							<v-card-text>
								<div>
									<h2 class="font-weight-black black--text text-xs-right mb-1">آدرس</h2>
								</div>
								<v-divider></v-divider>
								<br />
								<h3 class="font-weight-light grey--text text-xs-right mb-0">تبریز، خیابان امام، چهارراه
									شهید بهشتی،جنب بانک رفاه،ساختمان آرش، واحد 101</h3>
							</v-card-text>

							<v-card-actions>
								<v-spacer></v-spacer>
							</v-card-actions>
						</v-card>
					</v-hover>
				</v-flex>

				<v-flex xs12 sm6 md4 xl4>
					<v-hover>
						<v-card height="100%" slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 2}`" shaped>
							<v-responsive>
								<v-flex xs6 align-center flexbox>
									<v-icon size="200">
										mdi-pencil
										<br />
									</v-icon>
								</v-flex>
								<v-container fill-height fluid>
									<v-layout fill-height>
										<v-flex xs12 align-end flexbox></v-flex>
									</v-layout>
								</v-container>
							</v-responsive>
							<v-card-text>
								<div>
									<h2 class="font-weight-black black--text text-xs-right mb-1">فرم درخواست</h2>
								</div>
								<v-divider></v-divider>
								<br />
								<h3 class="font-weight-light grey--text text-xs-right mb-0">جهت ارسال درخواست های جدید،
									لطفا از فرم زیر استفاده نمایید.</h3>
							</v-card-text>

							<v-card-actions>
								<v-spacer></v-spacer>
								<v-btn to="/supportform?redirect=contact" text outlined
									class="font-weight-light black--text text-xs-right mb-0">ایجاد درخواست</v-btn>
							</v-card-actions>
						</v-card>
					</v-hover>
				</v-flex>
			</v-layout>
		</v-container>
		<v-container grid-list-lg> </v-container>
	</v-container>
</template>
<script>
export default {
	data: () => ({
		valid: false,
		name: "",
		subject: "",
		nameRules: [(v) => !!v || "وارد کردن فیلد الزامی است", (v) => v.length <= 15 || "حداکثر 15 حرف باشد"],
		email: "",
		emailRules: [(v) => !!v || "وارد کردن ایمیل الزامی است", (v) => /.+@.+/.test(v) || "ایمیل وارد شده صحیح نمی باشد"],
	}),
	methods: {
		submit() {
			if (this.$refs.form.validate()) {
				this.snackbar = "true";
			}
		},
	},
};
</script>
